import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('apuracao', 'gestao');

const apuracaoFixoActions = {
  basesCalculo: { method: 'GET', url: `${basePath}/bases-calculo` },
  buscaJustificativa: { method: 'GET', url: `${basePath}/{idApuracao}/justificativa-apuracao` },
  configuracao: { method: 'GET', url: `${basePath}/configuracao-apuracao` },
  formasBonificacoes: { method: 'GET', url: `${basePath}/formas-bonificacoes` },
  metasBeneficios: { method: 'GET', url: `${basePath}/metas-beneficios` },
  registraUsuario: { method: 'PUT', url: `${basePath}/{idApuracao}/registra/usuario` },
  unidadesMedida: { method: 'GET', url: `${basePath}/unidades-medida` },
  enviarFilaApuracao: { method: 'POST', url: `${basePath}/enviar-fila-apuracao` },
};

export default resource => resource(`${basePath}`, {}, apuracaoFixoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/apuracao-gestao.js